import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
// import axios from "axios";
import api from "../utils/api";
// Bileşen Importları
import BackGroundColor from "../CommanComponents/BackGroundColor";
import useCalculateSimilarity from "../hooks/useCalculateSimilarity";
import WordsTrEngCard from "../Component/WordsTrEngCard";
import AsistanCard from "../Component/AsistanCard";
import StudentCard from "../Component/StudentCard";
import HeaderCard from "../Component/HeaderCard";
import NextButton from "../Component/NextButton";
import BackButton from "../Component/BackButton";
import CelebrationComponent from "../Component/Celebrate";
import ArrayCounter from "../Component/ArrayCounter";
import { Vault } from "lucide-react";

function Grammar_1() {
  const [textValue, setTextValue] = useState(0);
  const [questionIndex, setQuestionIndex] = useState(0);
  const [activeLevel, setActiveLevel] = useState("Subject");
  const [isTeacherTurn, setIsTeacherTurn] = useState(true);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);
  const [similarityScore, setSimilarityScore] = useState(0);
  const [transcript, setTranscript] = useState("");
  const [isListening, setIsListening] = useState(false);
  const [grammarSubject, setGrammarSubject] = useState(null);
  const [grammarexamples, setGrammarexamples] = useState([]);
  const [grammarexercises, setGrammarexercises] = useState([]);
  const [completePart, setCompletePart] = useState(false);
  const [repeatExampleCount, setRepeatExampleCount] = useState({});
  const [repeatExercisesCount, setRepeatExercisesCount] = useState({});
  const [taskPackage, setTaskPackage] = useState({});

  // Eksik olan error ve recognition state'leri eklendi
  const [error, setError] = useState("");
  const [recognition, setRecognition] = useState(null);

  const contentValue = useSelector((state) => state.contents.contentValues);
  const navigate = useNavigate();

  const levelSet = [
    { name: "Subject", tr: "Konu" },
    { name: "examples", tr: "Örnekler" },
    { name: "exercises", tr: "Egzersizler" },
    { name: "Exıt", tr: "cıkış" },
  ];

  useEffect(() => {
    if (contentValue) {
      setGrammarSubject(contentValue.statement || null);
      setGrammarexamples(contentValue.examples || []);
      setGrammarexercises(contentValue.exercises || []);
    }
  }, [contentValue]);

  useEffect(() => {
    if (!contentValue || contentValue.length === 0) {
      console.log("İçerik boş, ana sayfaya yönlendiriliyor...");
      navigate("/");
    }
  }, [contentValue, navigate]);

  useEffect(() => {
    setTaskPackage({
      repeatExampleCount: repeatExampleCount,
      repeatExercisesCount: repeatExercisesCount,
    });
  }, [completePart, repeatExampleCount, repeatExercisesCount]);

  useEffect(() => {
    if (activeLevel === "examples") {
      setTextValue(0);
    } else if (activeLevel === "exercises") {
      setQuestionIndex(0);
    }
    setIsTeacherTurn(true);
    setTranscript("");
    setIsCorrect(false);
    setSimilarityScore(0);
    setError("");
  }, [activeLevel]);

  const { calculateSimilarity, getFeedbackMessage, getSimilarityColor } =
    useCalculateSimilarity();

  const safeStatement = contentValue?.statement || [];
  const mainStatement = safeStatement[0] || "Konu yükleniyor...";
  const statementDetails = safeStatement.slice(1) || [];

  // --- Web Speech API Entegrasyonu ---
  useEffect(() => {
    const SpeechRecognition =
      window.SpeechRecognition || window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      setError(
        "Your browser does not support Speech Recognition. Please use Google Chrome or Microsoft Edge.",
      );
      return;
    }

    const recognitionInstance = new SpeechRecognition();
    recognitionInstance.continuous = false;
    recognitionInstance.interimResults = false;
    recognitionInstance.lang = "en-US";

    recognitionInstance.onresult = (event) => {
      const spokenText = event.results[0][0].transcript;
      setTranscript(spokenText);

      // Aktif seviyeye göre hedef metni doğru seçiyoruz
      let expectedText = "";
      if (activeLevel === "examples") {
        expectedText = grammarexamples[textValue]?.Eng;
      } else if (activeLevel === "exercises") {
        expectedText = grammarexercises[questionIndex]?.Eng;
      }

      if (!expectedText) return;

      // Benzerlik skoru hesaplama
      const score = calculateSimilarity(spokenText, expectedText);
      setSimilarityScore(score);

      // %70 ve üzeri başarı kontrolü
      if (score >= 0.7) {
        setIsCorrect(true);
        setTimeout(() => goToNext(), 1500);
      } else {
        setIsCorrect(false);
      }
    };

    recognitionInstance.onerror = (event) => {
      setError(`Error occurred in recognition: ${event.error}`);
      setIsListening(false);
    };

    recognitionInstance.onend = () => {
      setIsListening(false);
    };

    setRecognition(recognitionInstance);

    return () => {
      if (recognitionInstance) {
        recognitionInstance.abort();
      }
    };
  }, [
    textValue,
    questionIndex,
    activeLevel,
    grammarexamples,
    grammarexercises,
  ]);

  const startListening = () => {
    setError("");
    setIsCorrect(false);
    setTranscript("");
    setSimilarityScore(0);
    setIsTeacherTurn(false);

    // Sayaçları Güncelle
    if (activeLevel === "examples") {
      setRepeatExampleCount((prev) => ({
        ...prev,
        [textValue]: (prev[textValue] || 0) + 1,
      }));
    } else if (activeLevel === "exercises") {
      setRepeatExercisesCount((prev) => ({
        ...prev,
        [questionIndex]: (prev[questionIndex] || 0) + 1,
      }));
    }

    if (recognition) {
      try {
        recognition.start();
        setIsListening(true);
      } catch (err) {
        console.error("Recognition start error:", err);
      }
    }
  };

  const stopServices = () => {
    if (window.speechSynthesis) window.speechSynthesis.cancel();
    if (recognition) {
      try {
        recognition.abort();
      } catch (e) {
        console.error(e);
      }
    }
    setIsListening(false);
    setIsSpeaking(false);
    setIsTeacherTurn(true);
    setTranscript("");
    setIsCorrect(false);
    setSimilarityScore(0);
  };

  const handleBackButton = () => {
    goToBack();
  };

  const handleNextButton = () => {
    goToNext();
  };

  const goToNext = () => {
    stopServices();
    if (activeLevel === "Subject") {
      setActiveLevel("examples");
      setTextValue(0);
    } else if (activeLevel === "examples") {
      const nextValue = textValue + 1;
      if (nextValue < grammarexamples.length) {
        setTextValue(nextValue);
      } else {
        setActiveLevel("exercises");
        setQuestionIndex(0);
      }
    } else if (activeLevel === "exercises") {
      const nextQuestion = questionIndex + 1;
      if (nextQuestion < grammarexercises.length) {
        setQuestionIndex(nextQuestion);
      } else {
        setCompletePart(true);
      }
    }
  };

  const goToBack = () => {
    stopServices();

    if (activeLevel === "exercises") {
      if (questionIndex > 0) {
        setQuestionIndex((prev) => prev - 1);
      } else {
        setActiveLevel("examples");
        setTextValue(grammarexamples.length - 1);
      }
    } else if (activeLevel === "examples") {
      if (textValue > 0) {
        setTextValue((prev) => prev - 1);
      } else {
        setActiveLevel("Subject");
      }
    }
  };

  const speakText = (text) => {
    if (!text || !("speechSynthesis" in window)) return;
    window.speechSynthesis.cancel();
    setIsSpeaking(true);
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.lang = "en-US";
    utterance.onend = () => {
      setIsSpeaking(false);
      setTimeout(() => setIsTeacherTurn(false), 500);
    };
    window.speechSynthesis.speak(utterance);
  };

  const handleLevelChange = (level) => {
    stopServices();
    if (level === "Exıt") {
      navigate("/");
    } else {
      setActiveLevel(level);
      setTextValue(0);
      setQuestionIndex(0);
    }
  };

  return (
    <div
      className="flex flex-col w-full gap-4"
      style={{
        fontFamily: "Inter, system-ui, -apple-system, sans-serif",
      }}
    >
      {/* Hata Bildirimi */}
      {error && (
        <div className="p-3 bg-red-100 text-red-700 rounded-xl text-sm border border-red-200">
          {error}
        </div>
      )}

      {/* celebrate */}
      <div className={`${completePart ? "block" : "hidden"}`}>
        {completePart ? (
          <CelebrationComponent
            setCompletePart={setCompletePart}
            taskPackage={taskPackage}
          />
        ) : null}
      </div>

      {/* grammar */}
      <div
        className={`${completePart ? "hidden" : "block"} flex flex-col gap-4 w-full`}
      >
        {/* Header */}
        <div className="w-full">
          <HeaderCard
            handleLevelChange={handleLevelChange}
            levelSet={levelSet}
            activeLevel={activeLevel}
          />
        </div>

        {/* contents */}
        <div className="w-full flex flex-col rounded-xl gap-4 p-2 bg-purple-500">
          <div>
            <div className="flex justify-between items-center">
              <BackButton handleBackButton={handleBackButton} />
              <div>
                {activeLevel === "examples" && (
                  <ArrayCounter
                    TextValue={textValue}
                    activeLevel={"examples"}
                  />
                )}
                {activeLevel === "exercises" && (
                  <ArrayCounter
                    TextValue={questionIndex}
                    activeLevel={"exercises"}
                  />
                )}
              </div>

              <NextButton handleNextButton={handleNextButton} />
            </div>

            {/* görsel içerik */}
            <div
              className="w-full bg-purple-500 py-3 md:py-4 flex
                     justify-between items-center flex-row gap-3 md:gap-8"
            >
              <div
                className="w-full md:p-12 flex flex-col justify-center
                     items-center md:flex-row gap-6 md:gap-8"
              >
                {activeLevel === "Subject" && (
                  <div
                    className="bg-white shadow-xl border-l-4 border-yellow-500
                       rounded-2xl p-4 md:p-6 hover:shadow-2xl transition-all w-full md:w-auto"
                  >
                    <div className="space-y-3">
                      <div>
                        <p className="text-md md:text-lg text-gray-700 leading-relaxed mb-4">
                          {mainStatement}
                        </p>

                        {statementDetails.map((item, index) => (
                          <div key={index} className="py-2 rounded mb-2">
                            <div
                              className="px-3 py-1 min-w-12 rounded-xl
                           text-md md:text-lg bg-yellow-500 font-semibold text-white"
                            >
                              {item.title || "Başlık"}
                            </div>
                            <p className="text-md md:text-lg text-gray-600 leading-relaxed">
                              {item.description || "Açıklama"}
                            </p>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                )}

                {activeLevel === "examples" && grammarexamples.length > 0 && (
                  <div className="flex flex-col justify-center items-center lg:flex-row gap-6 md:gap-8">
                    <div className="text-6xl lg:text-9xl drop-shadow-lg">
                      {grammarexamples[textValue]?.emoji}
                    </div>
                    <WordsTrEngCard
                      TextValue={textValue}
                      activeLevel={activeLevel}
                    />
                  </div>
                )}

                {activeLevel === "exercises" && grammarexercises.length > 0 && (
                  <div className="flex flex-col lg:flex-row lg:gap-2 justify-center items-center">
                    <div className="text-6xl lg:text-9xl drop-shadow-lg">
                      {grammarexercises[questionIndex]?.emoji}
                    </div>
                    <WordsTrEngCard
                      TextValue={questionIndex}
                      activeLevel={activeLevel}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Konuşma kartları */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 w-full">
            {(activeLevel === "examples" || activeLevel === "exercises") && (
              <AsistanCard
                isTeacherTurn={isTeacherTurn}
                speakText={speakText}
                isSpeaking={isSpeaking}
                TextValue={
                  activeLevel === "examples" ? textValue : questionIndex
                }
                activeLevel={activeLevel}
              />
            )}
            {(activeLevel === "examples" || activeLevel === "exercises") && (
              <StudentCard
                isCorrect={isCorrect}
                TextValue={
                  activeLevel === "examples" ? textValue : questionIndex
                }
                startListening={startListening}
                isTeacherTurn={isTeacherTurn}
                isListening={isListening}
                transcript={transcript}
                similarityScore={similarityScore}
                getFeedbackMessage={getFeedbackMessage}
                getSimilarityColor={getSimilarityColor}
                activeLevel={activeLevel}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Grammar_1;
